module.exports = __webpack_public_path__ + "img/value2.34af7b94.png";